<div id="activity" class="timeline-card-container" (contextmenu)="onContextMenu($event)">
  <div class="timeline-card" data-testid="card" (click)="onCardClick()">
    <!-- Icon Column -->
    <div class="card-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192">
        <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"
              d="M101.74 165.77a70.06 70.06 0 0 0 61.67-88.71M32.51 66.48a70.05 70.05 0 0 0 46.56 97.45M153.74 56.41A70 70 0 0 0 45.43 47.6"
              style="stroke: #e085fc;"/>
        <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"
              d="M158.18 35.11L155.1 57H133M12.18 72.59l20.49-8.28 11.06 19.15M117.64 180.3l-17.42-13.61 11.06-19.15"
              style="stroke: #7D0096;"/>
      </svg>
    </div>
    
    <!-- Content Column -->
    <div class="card-content">
      <!-- Hidden indicator at top-right -->
      @if (activity.isVisible == false) {
        <div class="status-container">
          <span class="hidden-indicator" title="Hidden">
            <rds-icon namespace="filled" icon="visibility_off"></rds-icon>
          </span>
        </div>
      }
      
      <!-- Title (Primary element) -->
      <h3 class="card-title" data-testid="event">{{ activity.event }}</h3>
      
      <!-- Flexible Tag Area (Optional) -->
      @if ((activity.strategicPillars && activity.strategicPillars.length > 0) || (activity.audiences && activity.audiences.length > 0)) {
        <div class="tags-container">
          @if (activity.strategicPillars && activity.strategicPillars.length > 0) {
            @for (sp of activity.strategicPillars; track sp) {
              <span class="strategic-pillar-tag" 
                    [style.background-color]="sp.color_code"
        [style.color]="getContrastColor(sp.color_code)"
                    [title]="'Strategic Pillar: ' + sp.title">
                {{ sp.title }}
              </span>
            }
          }
            @if (activity.audiences && activity.audiences.length > 0) {
              @for (aud of activity.audiences; track aud) {
                <span class="veeva-audience-tag"
                    [title]="'Audience: ' + aud.name">
                {{ aud.name }}
              </span>
              }
            }
        </div>
      }
      
      <!-- Studies or Keywords -->
      <div class="keywords-container">
        @if(getStudiesWithName().length > 0){
          @for(study of getStudiesWithName(); track study){
            <span class="study-tag" data-testclass="study">{{ study.studyName }}</span>
          }
        }
        @else{
          @for(keyword of activity.keyWords; track keyword){
            <span class="keyword-tag" data-testclass="study">{{ keyword }}</span>
          }
        }
      </div>
    </div>
  </div>
</div>
